import { makeStyles } from '@material-ui/core';

export default makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
    },
    icon: {
      marginLeft: '-5px',
      marginRight: '8px',

      '& svg': {
        display: 'block',
        fontSize: theme.typography.pxToRem(16),
      },
    },
    texts: {
      display: 'flex',
      flexFlow: 'column nowrap',
      flex: '1',
    },
    title: {
      marginBottom: theme.spacing(1),
    },
    content: {
      color: theme.palette.text.secondary,
      whiteSpace: 'pre-wrap',
    },
  }),
  { name: 'TooltipContent' }
);
